import React from "react";
import Footer from "../../assets/images/Footer.png";

const AuthorizePayment = () => {
  return (
    <div className="md:w-[562px] w-[300px] mt-40">
      <div className="flex  justify-between">
        <p className="text-primary text-xl font-bold">Tribe</p>
        <div>
          <p className="text-2xl text-primary font-bold">
            <span className="text-xl">NGN</span> 12,839.2
          </p>
          <p className="text-sm text-primary font-normal">(Fee NGN 100.00)</p>
          <p className="text-[17.75px] text-normalText font-normal">
            mbonnudebbie@gmail.com
          </p>
        </div>
      </div>
      <div className="flex justify-center">
        <p className="text-[18.75px] font-normal text-darkGrey text-center mt-10 w-[348px]">
          Authorise this payment on your phone via the payattitude app or ussd
          to complete this transaction
        </p>
      </div>
      <span className="flex justify-center mt-10">
        <svg
          width="150"
          height="150"
          viewBox="0 0 150 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M73.5352 6.41582C71.3672 7.11894 70.0488 8.26152 69.2871 10.0193C68.6133 11.66 68.6133 44.5896 69.2871 46.2303C71.1621 50.6834 77.2852 51.2693 80.127 47.2264L81.0059 45.9373L81.0937 28.7693C81.1523 17.0799 81.0937 11.2205 80.8594 10.4881C80.0391 7.64629 76.2305 5.53691 73.5352 6.41582Z"
            fill="#333333"
          />
          <path
            d="M28.2713 25.1657C25.1073 26.6306 23.7889 30.2048 25.2245 33.3982C25.6639 34.365 28.242 37.1482 34.951 43.8864C39.9901 48.9255 44.6776 53.4079 45.41 53.8474C47.285 54.9607 49.6873 54.9607 51.6209 53.8181C54.5506 52.1189 55.5467 48.281 53.8475 45.4099C53.408 44.6775 48.9256 39.99 43.8866 34.9509C34.1307 25.2536 33.369 24.6091 30.7616 24.6091C30.0291 24.6091 28.9159 24.8728 28.2713 25.1657Z"
            fill="#333333"
          />
          <path
            d="M116.602 25.2243C115.635 25.6638 112.852 28.2419 106.113 34.9509C101.074 39.99 96.5917 44.6775 96.1523 45.4099C94.4531 48.281 95.4492 52.1189 98.3788 53.8181C100.312 54.9607 102.715 54.9607 104.59 53.8474C105.322 53.4079 110.01 48.9255 115.049 43.8864C121.758 37.1482 124.336 34.365 124.775 33.3982C127.148 28.1247 121.875 22.8513 116.602 25.2243Z"
            fill="#333333"
          />
          <path
            d="M9.96087 69.3163C4.89252 71.5135 5.24408 79.3358 10.4882 80.8592C11.2206 81.0936 17.08 81.1522 28.7695 81.0936L45.9374 81.0057L47.2265 80.1268C51.2695 77.285 50.6835 71.162 46.2304 69.287C44.6191 68.6424 11.5136 68.6424 9.96087 69.3163Z"
            fill="#333333"
          />
          <path
            d="M103.711 69.3163C98.6425 71.5135 98.9941 79.3358 104.238 80.8592C104.971 81.0936 110.83 81.1522 122.519 81.0936L139.687 81.0057L140.976 80.1268C145.019 77.285 144.434 71.162 139.98 69.287C138.369 68.6424 105.264 68.6424 103.711 69.3163Z"
            fill="#333333"
          />
          <path
            d="M46.5527 95.5953C44.8241 96.2398 44.2382 96.7965 34.8046 106.259C28.2128 112.88 25.664 115.634 25.2245 116.601C22.8515 121.875 28.1249 127.148 33.3984 124.775C34.3651 124.336 37.1484 121.757 43.8866 115.048C48.9257 110.009 53.4081 105.322 53.8476 104.589C55.5175 101.777 54.5507 97.8805 51.7382 96.2398C50.1855 95.3316 47.9882 95.068 46.5527 95.5953Z"
            fill="#333333"
          />
          <path
            d="M99.8436 95.4781C95.9179 96.7379 94.1308 101.191 96.1522 104.589C96.5917 105.322 101.074 110.009 106.113 115.048C112.851 121.757 115.635 124.336 116.601 124.775C121.875 127.148 127.148 121.875 124.775 116.601C124.336 115.634 121.758 112.851 115.049 106.113C110.01 101.074 105.351 96.5914 104.707 96.2105C103.359 95.4195 101.103 95.0973 99.8436 95.4781Z"
            fill="#333333"
          />
          <path
            d="M73.5352 100.166C71.3672 100.869 70.0488 102.012 69.2871 103.769C68.6133 105.41 68.6133 138.34 69.2871 139.98C71.1621 144.433 77.2852 145.019 80.127 140.976L81.0059 139.687L81.0937 122.519C81.1523 110.83 81.0937 104.971 80.8594 104.238C80.0391 101.396 76.2305 99.2869 73.5352 100.166Z"
            fill="#333333"
          />
        </svg>
      </span>
      <div className="flex justify-center mt-4">
        <p className="text-[18.75px] font-normal text-lightBlack">
          Expires in: 04:57
        </p>
      </div>
      <div className="flex justify-center">
        <button className=" text-white text-[14.75px] w-[307px] rounded-[10px] bg-orangeCard py-[20.19px] mt-4">
          I have authorised this payment
        </button>
      </div>
      <div className="flex justify-center mt-6 mb-2">
        <img src={Footer} alt="footerLogo" className="w-[227px]" />
      </div>
    </div>
  );
};

export default AuthorizePayment;
